<template>
  <div>
    <!--  <el-input @input="onInput($event)" size="mini" v-model="item.value" ></el-input>-->
    <span style="color:#248cfa;">{{item.text}}：</span>
    <input :placeholder=" item.regTips ?`输入${item.regTips}的数` : ''" style="border: 1px solid #C0C4CC;width: 150px;border-radius: 4px;padding: 5px 10px"  @change="onInput($event)" v-model="item.value"/>
  </div>
</template>

<script>
export default {
  name: "completion",
  props: ['item'],
  mounted() {

  },
  methods: {
    // checkValue (event) {
    //   event.target.value = event.target.value.replace(/\-/g, '')
    // },
    onInput(event) {
      console.log(event.target.value);
      // event.target.value = event.target.value.replace('f',"")
      let reg = new RegExp(this.item.reg)
      if(!reg.test(event.target.value)) {
        event.target.value = event.target.value.replace(event.target.value,"")
      }
    }
  }
}
</script>

<style scoped>
input::placeholder {
  color: #ccc;
}
</style>